import { Paper, Stack, Typography } from "@mui/material";
import {
  CheckCircle,
  Error as ErrorIcon,
  PlayArrow,
} from "@mui/icons-material";

const CARD_SX = {
  p: 1.5,
  borderLeft: "6px solid",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  gap: 1,
  width: 140,
  flexShrink: 0,
};

const LABEL_SX = {
  fontWeight: "bold",
  color: "text.secondary",
  fontSize: "0.6rem",
  lineHeight: 1.2,
};

function StatCard({ label, count, borderColor, icon }) {
  return (
    <Paper elevation={2} sx={{ ...CARD_SX, borderLeftColor: borderColor }}>
      <Stack>
        <Typography
          variant="overline"
          sx={{ ...LABEL_SX, whiteSpace: "nowrap" }}
        >
          {label}
        </Typography>
        <Typography variant="h5" sx={{ fontWeight: "bold" }}>
          {count}
        </Typography>
      </Stack>
      {icon}
    </Paper>
  );
}

export function IngestionStats({
  strings,
  finishedCount,
  inProgressCount,
  errorCount,
}) {
  return (
    <>
      <StatCard
        label={strings.finished}
        count={finishedCount}
        borderColor="success.main"
        icon={<CheckCircle color="success" />}
      />
      <StatCard
        label={strings.inProgress}
        count={inProgressCount}
        borderColor="warning.light"
        icon={<PlayArrow sx={{ color: "warning.light", fontSize: "2rem" }} />}
      />
      <StatCard
        label={strings.error}
        count={errorCount}
        borderColor="error.main"
        icon={<ErrorIcon color="error" />}
      />
    </>
  );
}
